export default class Venues{
    constructor(name="",address="",seat="",managers=[], location = {}){
        this.name=name
        this.address=address
        this.seat=seat
        this.managers=managers
        this.location = location
    }
}